import React from "react";

export default function SelectableCard({ icon, label, checked, onChange }) {
    return (
        <label className={`select-card ${checked ? "checked" : ""}`}>
            <input
                type="checkbox"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
            />

            <div className="select-card-inner">                
                <div className="icon">{icon}</div>
                <div className="label">{label}</div>
            </div>

            <div className="checkmark">✓</div>
        </label>
    );
}